import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Type, ViewChild } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { ReportKindInfo } from "projects/sepidz-web-framework-data-grid/src/lib/report-kind";
import { ReportCopyComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-copy.component";
import { ReportSelectorComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-selector.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { SplashScreenService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/SplashScreenService";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import "projects/sepidz-web-framework/src/lib/interceptors/extensions";
import { DetailLedger, form_control, SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { ReportKind, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter, isNumber, LookupService, PagingDataResult, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { BehaviorSubject, Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ReportInfo, StimulSoftReportComponent } from "src/app/stimul-soft-report/stimul-soft-report.component";
import { AccVoucherFormComponent } from "../../../acc/accvoucher/accvoucher-form/accvoucher-form.component";
import { SettlementVoucher } from "../../models/settlement-voucher.model";
import { TrsStatusKind } from "../../models/tresury.enums";
import { TrsConcern } from "../../models/trs-concern.model";
import { TrsReferenceVoucherByVoucherKindFilterInfo } from "../../models/trs-reference-voucher-byvoucher-kindfilterinfo";
import { TrsSettlementVoucher } from "../../models/trs-settlement-voucher.model";
import { TrsVoucherDetail } from "../../models/trs-voucher-detail.model";
import { TrsVoucherHeader } from "../../models/trs-voucher-header.model";
import { TrsVoucherKind } from "../../models/trs-voucher-kind.model";
import { ChequeBookInfoFormComponent } from "../cheque-book-info/cheque-book-info-form.component";
import { TrsVoucherDetailComponent } from "../trs-voucher-detail/trs-voucher-detail.component";
import { TrsVoucherModalListComponent } from "../trs-voucher-modal-list/trs-voucher-modal-list.component";
@Component({
  selector: "ngx-trs-voucher-form",
  templateUrl: "./trs-voucher-form.component.html",
  styleUrls: ["./trs-voucher-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrsVoucherFormComponent extends BaseFormComponent<TrsVoucherHeader> {
  TrsSettlementVoucherColumns: form_control[];
  @ViewChild("detail") public detail: TrsVoucherDetailComponent;
  @ViewChild("grid") public grid: KGridComponent;
  inputEditorform: Type<any>;
  currentVoucherKind: TrsVoucherKind;
  currentSelectedRow: TrsVoucherDetail;
  _currentSettlementConcern: TrsConcern;
  set currentSettlementConcern(value: TrsConcern) {
    this._currentSettlementConcern = value;
  }
  get currentSettlementConcern(): TrsConcern {
    if (!this._currentSettlementConcern && this.model?.TrsVoucherDetails && this.model?.TrsVoucherDetails.length > 0) {
      this._currentSettlementConcern = <TrsConcern>{};
      this._currentSettlementConcern.Id = this.model.TrsVoucherDetails.find((x) => x.InvVoucherKindId)?.ConcernId;
      this._currentSettlementConcern.InvVoucherKindId = this.model.TrsVoucherDetails.find((x) => x.InvVoucherKindId)?.InvVoucherKindId;
      this._currentSettlementConcern.Code = this.model.TrsVoucherDetails.find((x) => x.InvVoucherKindId)?.ConcernCode;
      this._currentSettlementConcern.Title = this.model.TrsVoucherDetails.find((x) => x.InvVoucherKindId)?.ConcernTitle;
      this._currentSettlementConcern.IsWarehouse = this.model.TrsVoucherDetails.find((x) => x.InvVoucherKindId)?.IsWarehouse;
    }
    return this._currentSettlementConcern;
  }
  grdSettlementVoucher: SettlementVoucher[];
  isValidating: boolean = false;
  isOkForLoad: boolean = false;
  erroremessage: string;
  isloading: boolean = false;
  goodsError: boolean = false;
  maxCodeLoading: boolean = false;
  isNewVoucher: boolean = false;
  confirmLabel: string;
  isVoucherConfirmed: boolean = false;
  currentReport: string = "print";
  TrsVoucherDetailsColumns: form_control[];
  reportKinds = ReportKindInfo.reportKinds;
  activeTabTitle: string;
  SelectedSettlement: number[];
  constructor(
    private lookupservice: LookupService,
    protected cd: ChangeDetectorRef,
    protected selectorService: SelectorService,
    private missetup: MisSetupService,
    private splashScreenService: SplashScreenService,
    private splashFormService: SplashFormService,
    __id: FormContainerModel,
    _tabsservice: TabularService,
    private datatransfer: Datatransfer,
    _VoucherKindInfo: VoucherKindInfo
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.currentrow = this.datatransfer?.currentrow;
    if (this.datatransfer?.apiName) this.apiName = this.datatransfer?.apiName;
    if (this.datatransfer?.areaName) this.areaName = this.datatransfer?.areaName;
    this.VoucherKind = _VoucherKindInfo;
    this.tabsservice = _tabsservice;
    this.currentFiscalYear;
    this.onDataStateChange = this.onDataStateChange.bind(this);
  }
  _currentDetailLedger: DetailLedger;
  get currentDetailLedger(): DetailLedger {
    if (!this._currentDetailLedger || !this._currentDetailLedger.Id) {
      this._currentDetailLedger = <DetailLedger>{};
      if (this.currentVoucherKind.DetailLedgerInHeader === true) {
        this._currentDetailLedger.Id = this.formGroup?.get("DetailLedgerId")?.value;
        this._currentDetailLedger.Code = this.formGroup?.get("DetailLedgerCode")?.value;
        this._currentDetailLedger.Title = this.formGroup?.get("DetailLedgerTitle")?.value;
      } else {
        this._currentDetailLedger.Id = this.model.TrsVoucherDetails[0].DetailLedgerId;
        this._currentDetailLedger.Code = this.model.TrsVoucherDetails[0].DetailLedgerCode;
        this._currentDetailLedger.Title = this.model.TrsVoucherDetails[0].DetailLedgerTitle;
      }
    }
    return this._currentDetailLedger;
  }
  get filterEntity() {
    let entity: TrsReferenceVoucherByVoucherKindFilterInfo = <TrsReferenceVoucherByVoucherKindFilterInfo>{};
    entity.FiscalYearId = this.currentFiscalYear.Id;
    if (!this.formGroup.controls["DetailLedgerId"].disabled)
      entity.DetailLedgerId = this.formGroup.controls["DetailLedgerId"] ? this.formGroup.controls["DetailLedgerId"].value : undefined;
    entity.ReferencedVoucherKindId = this.formGroup.controls["ReferenceVoucherKindId"]
      ? this.formGroup.controls["ReferenceVoucherKindId"].value
      : undefined;
    entity.VoucherDate = this.formGroup.controls["VoucherDate"] ? this.formGroup.controls["VoucherDate"].value : undefined;
    entity.VoucherKindId = this.formGroup.controls["TrsVoucherKindId"] ? this.formGroup.controls["TrsVoucherKindId"].value : undefined;
    if (!this.formGroup.controls["TreasuryDetailLedgerId"].disabled)
      entity.TreasuryDetailLedgerId = this.formGroup.controls["TreasuryDetailLedgerId"]
        ? this.formGroup.controls["TreasuryDetailLedgerId"].value
        : undefined;
    entity.ConcernId = this.currentSettlementConcern?.Id;
    entity.ConcernCode = this.currentSettlementConcern?.Code;
    entity.ConcernTitle = this.currentSettlementConcern?.Title;
    entity.InvVoucherKindId = this.currentSettlementConcern?.InvVoucherKindId;
    entity.IsWarehouse = this.currentSettlementConcern?.IsWarehouse;
    return entity;
  }
  get ReferenceVoucherKindId() {
    if (this.formGroup && this.formGroup.controls["ReferenceVoucherKindId"]) return this.formGroup.controls["ReferenceVoucherKindId"].value;
    return undefined;
  }

  get hasReference() {
    return (
      this.currentVoucherKind && this.currentVoucherKind?.TrsReferenceVoucherKinds && this.currentVoucherKind?.TrsReferenceVoucherKinds.length > 0
    );
  }
  get hasReferenceRequired() {
    return this.currentVoucherKind && this.currentVoucherKind?.TrsReferenceVoucherKinds && this.currentVoucherKind?.ReferenceVoucherKindIsRequired;
  }
  get currentFiscalYear() {
    return this.accountService.authService.currentFiscalYear;
  }
  get HasJournalVoucher() {
    return this.currentVoucherKind?.HasJournalVoucher;
  }
  get headerTitleToDetailTitle(): string {
    return this.formGroup.controls["Comment"].value;
  }
  async ngOnInit() {
    this.setCurrentVoucherKind();
    if (this.currentrow && this.currentrow["VoucherHeaderId"]) this.currentrow.Id = this.currentrow["VoucherHeaderId"];
    this.isNewVoucher = false;
    this.isVoucherConfirmed = false;
    this.apiName = "TrsVoucherHeader";
    this.areaName = "Treasury";

    this.missetup.getnumber("ACC", "DLLEVEL");
    this.ReportSelectorForm = ReportSelectorComponent;
    this.ReportCopyForm = ReportCopyComponent;
    this.reportName = "TrsentoryDocument";
    this.pathPreFix = "TRS";

    await super.ngOnInit();

    this.loadReports();
    if (this.detail) {
      this.detail.dataList = this.model?.TrsVoucherDetails ?? [];
      this.detail.ngOnInit();
    }
    this.setTrsVoucherDetailsColumns();
  }

  isNoValidForEdit() {
    let StatusKindCode: number = TrsStatusKind.Confirmed;
    return !this.isNewRow && this.model && this.model.StatusKindCode >= StatusKindCode;
  }

  setStatusKind() {
    if (this.model.TrsVoucherKindId && this.VoucherKind.VoucherKindId !== this.model.TrsVoucherKindId) {
      this.VoucherKind = new VoucherKindInfo();
      this.VoucherKind.VoucherKindId = this.model.TrsVoucherKindId;
    }
    if (!this.model.StatusKindId && this.formGroup && !this.formGroup?.controls["StatusKindId"]?.value) {
      this.lookupservice
        .getLookupbyCode("TRS", "StatusKind", TrsStatusKind.Registered)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", this.model.StatusKindId);
            this.setValue("StatusKindCode", this.model.StatusKindCode);
            this.setValue("StatusKindTitle", this.model.StatusKindTitle);
            this.confirmLabel = "تایید سند";
          }
        });
    }
    if (this.model.StatusKindCode >= TrsStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
    else this.confirmLabel = "تایید";
  }
  afterupdate() {
    if (this.model.AccVoucherFixNumber > 0) return;
    super.afterupdate();
    setTimeout(() => {
      if (
        !this.isVoucherConfirmed &&
        this.model?.StatusKindCode === TrsStatusKind?.Confirmed &&
        this.currentVoucherKind?.HasJournalVoucher &&
        this.currentVoucherKind?.HasJournalVoucherAuto
      ) {
        let gridFilter: GridFilter[] = [];
        let TrsVoucherHeaderIds: number[] = [];
        TrsVoucherHeaderIds.push(this.model.Id);
        let filter: GridFilter = {
          Type: "F",
          Filed: "TrsVoucherHeaderIds",
          Value: TrsVoucherHeaderIds,
          Logic: "and",
          Operator: "eq",
          Skip: 0,
          Take: 0,
        };
        gridFilter.push(filter);
        this.createAccVoucher(gridFilter);
      }
    }, 200);
  }
  closeForm(flag: boolean = false) {
    if (flag && !this.isNewVoucher) {
      if (this._id?.metadata?.id) {
        this.tabsservice.tabItemonRefreshData.next(this.apiName);
        this.tabsservice.tabItemOnCanClosing.next(this._id?.metadata?.id);
      }
      this.close();
    }
    if (this.isNewVoucher && flag) {
      this.selectorService.submitted$.next(false);
      this.model = undefined;
      this.currentrow = undefined;
      this.ngOnInit().then();
    }
    this.isClosing = false;
  }
  isCloseable() {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    this.currentrow = this.model;
    this.ngOnInit().then();
    return false;
  }
  canDeactivate() {
    if (
      !(
        (this.formGroup && this.formGroup.dirty && this.formGroup.touched) ||
        (this.model?.TrsVoucherDetails?.length > 0 &&
          this.model?.TrsVoucherDetails?.some((x) => x.State === RowState.New || x.State === RowState.Modify))
      )
    )
      return true;
    this.sts.showDialog(
      "شما اطلاعات ذخیره نشده دارید! در صورت خروج اطلاعات از دست خواهد رفت.",
      "هشدار",
      DialogType.confirm,
      () => this.closeForm(true),
      () => this.closeForm(false)
    );
    return false;
  }
  setdefault() {
    if (this.model && this.model.TrsVoucherKindTitle) {
      this.label = this.model.TrsVoucherKindTitle + `(${this.model.VoucherNo ?? 0})`;
      this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
    }
    this.setStatusKind();
    if (!this.model.VoucherDate && this.currentVoucherKind && this.currentVoucherKind?.ToDayDate) this.model.VoucherDate = new Date();

    if (!this.model.TrsVoucherDetails) this.model.TrsVoucherDetails = [];
    else this.VoucherSelectionChanged();
    if (!this.model.FiscalYearId && this.currentFiscalYear) {
      this.model.FiscalYearId = this.currentFiscalYear.Id;
    } else if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.model.FiscalYearId = x.Id;
          this.setValue("FiscalYearId", x.Id);
        }
      });
    }

    if (!this.model.TrsVoucherKindId && this.currentVoucherKind) {
      this.model.TrsVoucherKindId = this.currentVoucherKind?.Id;
      this.model.TrsVoucherKindCode = this.currentVoucherKind?.Code;
      this.model.TrsVoucherKindTitle = this.currentVoucherKind?.Title;
    } else if (!this.model.TrsVoucherKindId && this.VoucherKind.VoucherKindId) {
      this.model.TrsVoucherKindId = this.VoucherKind.VoucherKindId;
    }
    if (!this.model.BranchId) {
      this.model.BranchId = this.accountService.authService.currentBranchId;
    }
    if (!this.model.SlaveNo) this.model.SlaveNo = 0;
    if (!this.model.TotalPrice) this.model.TotalPrice = 0;
    if (this.model.TrsVoucherKindTitle && this._id) {
      this.label = this.model.TrsVoucherKindTitle + `(${this.model.VoucherNo ?? 0})`;
      this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
    }
    this.setDefaultValues();
    if (this.model && this.model?.TrsVoucherDetails && this.model?.TrsVoucherDetails?.length > 0 && this.detail) {
      this.detail.dataList = this.model?.TrsVoucherDetails;
    } else if (this.detail?.dataList?.length > this.model?.TrsVoucherDetails?.length) this.detail.dataList = this.model?.TrsVoucherDetails;

    if (this.detail && !this.isNewRow) setTimeout(() => this.detail.cancelHandler(), 50);
    this.setColumnAttribute();
    setTimeout(() => {
      if (this.detail) {
        this.detail.dataList.forEach((x) => {
          if (x.Id > 0) x.State = RowState.NoChange;
        });
      }
      this.setAllUnTouched();
    }, 100);
  }
  setMaxCode() {
    if (!this.isNewRow || this.maxCodeLoading) return;

    this.maxCodeLoading = true;
    if (this.currentFiscalYear) {
      var fiscalYearId = this.currentFiscalYear.Id;
      this.httpCommonService
        .getMaxCode(this.apiName + "/" + this.VoucherKind.VoucherKindId + "/" + fiscalYearId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            if (!this.model) this.model = <TrsVoucherHeader>{};
            if (data && data["VoucherNumber"]) {
              this.model["VoucherNo"] = data["VoucherNumber"] as number;
              if (this.currentVoucherKind && this.currentVoucherKind?.ToDayDate) this.model["VoucherDate"] = new Date();
              else this.model["VoucherDate"] = data["VoucherDate"] as Date;
              if (!this.formGroup) {
                this.setdefault();
                this.setFormGroup(this.model);
              } else {
                this.setValue("VoucherNo", data["VoucherNumber"] as number);
                this.setValue("VoucherDate", this.model["VoucherDate"]);
              }
            }
            this.maxCodeLoading = false;
          },
          (error) => (this.maxCodeLoading = false)
        );
    } else {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          var fiscalYearId = x.Id;
          this.httpCommonService
            .getMaxCode(this.apiName + "/" + this.VoucherKind.VoucherKindId + "/" + fiscalYearId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data && data["VoucherNumber"]) {
                  this.model["VoucherNo"] = data["VoucherNumber"] as number;
                  if (this.currentVoucherKind && this.currentVoucherKind?.ToDayDate) this.model["VoucherDate"] = new Date();
                  else this.model["VoucherDate"] = data["VoucherDate"] as Date;
                  if (!this.formGroup) {
                    this.setdefault();
                    this.setFormGroup(this.model);
                  } else {
                    this.setValue("VoucherNo", data["VoucherNumber"] as number);
                    this.setValue("VoucherDate", data["VoucherDate"] as Date);
                  }
                }
                this.maxCodeLoading = false;
              },
              (error) => (this.maxCodeLoading = false)
            );
        }
      });
    }
  }

  setCurrentVoucherKind() {
    this.httpCommonService
      .getItem<TrsVoucherKind>("TrsVoucherKind", this.VoucherKind.VoucherKindId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data?.TreasuryDetailLedgerInHeader) this.selectorService.setDataStateChange("TreasuryDetailLedgerId", this.onDataStateChange);
          if (data?.DetailLedgerInHeader) this.selectorService.setDataStateChange("DetailLedgerId", this.onDataStateChange);
          this.setValue("TrsVoucherKindId", this.VoucherKind.VoucherKindId);
          this.currentVoucherKind = Object.assign({}, data as TrsVoucherKind);
          this.model.TrsVoucherKindId = this.currentVoucherKind?.Id;
          this.model.TrsVoucherKindCode = this.currentVoucherKind?.Code;
          if (this._id && this.model.VoucherNo) {
            this.label = data.Title + `(${this.model.VoucherNo ?? 0})`;
            this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
          }
          this.setValue("TrsVoucherKindCode", this.currentVoucherKind?.Code);
          if (this.hasReference) this.setReferenceVoucherColumns();
          this.setMaxCode();

          this.setColumnAttribute();
        },
        (error) => this.getFailedHelper(error)
      );
  }

  setColumnAttribute() {
    super.setColumnAttribute();
    this.isOkForLoad = false;
    if (!this.orignalColumns) return;
    this.orignalColumns.forEach((x) => {
      if (x.name === "SubLedgerId") {
        if (this.currentVoucherKind) {
          x.disabled = !this.currentVoucherKind?.ShowSubLedger || !this.currentVoucherKind?.SubledgerInHeader;
          if (this.model && this.model.TrsVoucherDetails && this.model.TrsVoucherDetails.length > 0) {
            this.setValue("SubLedgerId", this.model.TrsVoucherDetails[0].SubLedgerId);
            if (this.model) this.model.SubLedgerId = this.model.TrsVoucherDetails[0].SubLedgerId;
          } else if (this.isNewRow) {
            this.setValue("SubLedgerId", this.currentVoucherKind?.DefaultSubLedgerId);
            if (this.model) this.model.SubLedgerId = this.currentVoucherKind?.DefaultSubLedgerId;
          }
          if (this.formGroup && this.formGroup.get("SubLedgerId")) {
            if (x.disabled) this.formGroup.get("SubLedgerId").disable();
            else this.formGroup.get("SubLedgerId").enable();
          }
        }
      }
      if (x.name === "ConcernId") {
        if (this.currentVoucherKind) {
          x.disabled = !this.currentVoucherKind?.ConcernInHeader;
          this.setConcernVoucherKind();
          if (this.model && this.model.TrsVoucherDetails && this.model.TrsVoucherDetails.length > 0) {
            this.setValue("ConcernId", this.model.TrsVoucherDetails[0].ConcernId);
            this.model.ConcernId = this.model.TrsVoucherDetails[0].ConcernId;
          } else if (this.currentVoucherKind?.TrsVoucherKindConcerns && this.currentVoucherKind?.TrsVoucherKindConcerns.length > 0) {
            const concern = this.currentVoucherKind?.TrsVoucherKindConcerns.find((x) => x.IsDefault);
            this.setValue("ConcernId", !concern ? undefined : concern.TrsConcernId);
            if (this.model) this.model.ConcernId = !concern ? undefined : concern.TrsConcernId;
          } else this.setValue("ConcernId", undefined, true);
          if (this.formGroup && this.formGroup.get("ConcernId")) {
            if (x.disabled) this.formGroup.get("ConcernId").disable();
            else this.formGroup.get("ConcernId").enable();
          }
        }
      }
      if (x.name === "DetailLedgerId") {
        if (this.currentVoucherKind) {
          x.disabled = !this.currentVoucherKind?.DetailLedgerInHeader;
          x.required = this.currentVoucherKind?.RequireDetailLedger;
          if (this.currentVoucherKind?.DetailLedgerCaption) x.label = this.currentVoucherKind?.DetailLedgerCaption;
          if (this.model && this.model.TrsVoucherDetails && this.model?.TrsVoucherDetails?.length > 0) {
            this.setValue("DetailLedgerId", this.model.TrsVoucherDetails[0].DetailLedgerId, true);
            this.model.DetailLedgerId = this.model.TrsVoucherDetails[0].DetailLedgerId;
          } else this.setValue("DetailLedgerId", undefined, true);
          if (this.formGroup && this.formGroup.get("DetailLedgerId")) {
            if (x.disabled) this.formGroup.get("DetailLedgerId").disable();
            else this.formGroup.get("DetailLedgerId").enable();
          }
        }
      }
      if (x.name === "TreasuryDetailLedgerId") {
        if (this.currentVoucherKind && this.currentVoucherKind?.ShowTreasuryDetailLedger === true) {
          x.disabled = !(this.currentVoucherKind?.TreasuryDetailLedgerInHeader && this.currentVoucherKind?.ShowTreasuryDetailLedger === true);
          x.required = this.currentVoucherKind?.RequireTreasuryDetailLedger;
          if (this.currentVoucherKind?.TreasuryDetailLedgerCaption) x.label = this.currentVoucherKind?.TreasuryDetailLedgerCaption;
          if (this.model && this.model.TrsVoucherDetails && this.model.TrsVoucherDetails.length > 0) {
            this.setValue("TreasuryDetailLedgerId", this.model.TrsVoucherDetails[0].TreasuryDetailLedgerId, x.required);
            this.model.TreasuryDetailLedgerId = this.model.TrsVoucherDetails[0].TreasuryDetailLedgerId;
          }
        } else {
          x.disabled = !(this.currentVoucherKind?.TreasuryDetailLedgerInHeader && this.currentVoucherKind?.ShowTreasuryDetailLedger === true);
          this.setValue("TreasuryDetailLedgerId", undefined, x.required);
          if (this.formGroup && this.formGroup.get("TreasuryDetailLedgerId")) {
            if (x.disabled) this.formGroup.get("TreasuryDetailLedgerId").disable();
            else this.formGroup.get("TreasuryDetailLedgerId").enable();
          }
        }
      }
      if (x.name === "ReferenceVoucherKindId") {
        x.disabled = !this.hasReference;
        if (!x.disabled) x.required = this.hasReferenceRequired;
        if (!x.disabled) {
          this.setReferenceVoucherKind();
          let vk = this.currentVoucherKind?.TrsReferenceVoucherKinds.find((vk) => vk.IsDefault);
          if (vk) {
            if (this.model) this.model.ReferenceVoucherKindId = vk.ReferenceVoucherKindId;
            this.setValue("ReferenceVoucherKindId", vk.ReferenceVoucherKindId);
          }
        }
        if (this.formGroup && this.formGroup.get("ReferenceVoucherKindId")) {
          if (x.disabled) this.formGroup.get("ReferenceVoucherKindId").disable();
          else this.formGroup.get("ReferenceVoucherKindId").enable();
        }
      }
    });

    if (this.isNoValidForEdit()) {
      this.orignalColumns.forEach((x) => {
        x.disabled = true;
        if (this.formGroup && this.formGroup.get(x.name)) {
          if (x.disabled) this.formGroup.get(x.name).disable();
          else this.formGroup.get(x.name).enable();
          this.formGroup.get(x.name).updateValueAndValidity();
        }
      });
    } else {
      this.orignalColumns.forEach((x) => {
        if (this.formGroup && this.formGroup.get(x.name)) {
          if (x.disabled) this.formGroup.get(x.name).disable();
          else this.formGroup.get(x.name).enable();
          this.formGroup.get(x.name).updateValueAndValidity();
        }
      });
    }
    if (this.currentVoucherKind && this.currentVoucherKind?.Title) {
      this.label = this.currentVoucherKind?.Title + `(${this.model?.VoucherNo ?? 0})`;
      if (this._id) this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
    }
    if (this.formGroup) {
      this.formGroup.updateValueAndValidity();
    }
    if (this.currentVoucherKind) {
      this.isOkForLoad = true;
      this.cd.markForCheck();
    }
    if (!this.TrsVoucherDetailsColumns || this.TrsVoucherDetailsColumns.length <= 0) {
      this.TrsVoucherDetailsColumns = this.getDetailControlModels("TrsVoucherDetails");
      this.TrsVoucherDetailsColumns.forEach((x) => {
        if (x.name === "TreasuryDetailLedgerId") {
          x.listVisible = this.currentVoucherKind?.ShowTreasuryDetailLedger && !this.currentVoucherKind?.TreasuryDetailLedgerInHeader;
          x.label = this.currentVoucherKind?.TreasuryDetailLedgerCaption ?? x.label;
        }
        if (x.name === "ShowSubLedger") {
          x.listVisible = this.currentVoucherKind?.ShowSubLedger && !this.currentVoucherKind?.SubledgerInHeader;
          x.label = this.currentVoucherKind?.TreasuryDetailLedgerCaption ?? x.label;
        }
        if (x.name === "BankAccountId") x.listVisible = this.currentVoucherKind?.OperationKindCode === 2;
        if (x.name === "BankAccountNo") x.listVisible = this.currentVoucherKind?.OperationKindCode === 1;
      });
      
    }
    this.columns.forEach((x) => (x.isFloat = null, x.userClass = null));
    this.cd.markForCheck();
  }
  setReferenceVoucherKind() {
    this.httpCommonService
      .get("TrsVoucherKind/ReadLookUp")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          let vk = (data as TrsVoucherKind[]).filter((x) =>
            this.currentVoucherKind?.TrsReferenceVoucherKinds?.some((vk) => vk.ReferenceVoucherKindId === x.Id)
          );
          this.selectorService.setDataList("ReferenceVoucherKindId", vk);
        },
        (error) => this.getFailedHelper(error)
      );
  }
  setConcernVoucherKind() {
    this.httpCommonService
      .get("TrsConcern/GetLookup")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          let vk = (data as TrsConcern[]).filter((x) => this.currentVoucherKind?.TrsVoucherKindConcerns.some((vk) => vk.TrsConcernId === x.Id));
          if (!vk) vk = [];
          this.selectorService.setDataList("ConcernId", vk);
        },
        (error) => this.getFailedHelper(error)
      );
  }
  setDefaultValues() {
    this.orignalColumns.forEach((x) => {
      if (x.controlType === FormControlTypes.checkbox && this.model[x.name] === undefined) this.model[x.name] = false;
      if (x.name === "VoucherDate") x.disabled = this.currentVoucherKind && this.currentVoucherKind?.HasCheckVoucherDate;
    });
  }
  onHeaderValueChange($event) {
    if (!this.isValidating) this.isValid();
  }
  onValueChanges($event) {
    this.currentSelectedRow = $event;
    if (this.detail && this.detail?.dataList && this.model) this.model.TrsVoucherDetails = this.detail?.dataList;
    if (
      this.model &&
      this.currentVoucherKind?.DetailLedgerInHeader &&
      !this.formGroup.controls["DetailLedgerId"].value &&
      !this.model.DetailLedgerId
    ) {
      this.model.DetailLedgerId = this.model.TrsVoucherDetails[0].DetailLedgerId;
      this.setValue("DetailLedgerId", this.model.DetailLedgerId);
    }
    if (
      this.model &&
      this.currentVoucherKind?.DetailLedgerInHeader &&
      !this.formGroup.controls["TreasuryDetailLedgerId"].value &&
      !this.model.TreasuryDetailLedgerId
    ) {
      this.model.TreasuryDetailLedgerId = this.model.TrsVoucherDetails[0].TreasuryDetailLedgerId;
      this.setValue("TreasuryDetailLedgerId", this.model.TreasuryDetailLedgerId);
    }
    if (!this.isValidating) this.isValid();
  }
  onValueChangeByApiName($event) {
    if ($event?.apiName && $event?.data && $event?.data.Id && $event?.apiName.includes("TrsConcern/GetLookup") && $event?.data?.InvVoucherKindId) {
      this.currentSettlementConcern = $event?.data;
    }
    if ($event?.apiName && $event?.data && $event?.data?.Id && $event?.apiName?.includes("DetailLedger/GetPagining")) {
      this._currentDetailLedger = $event?.data;
    }
    if (!this.currentSettlementConcern || this.currentSettlementConcern.InvVoucherKindId) this.SetSettlementChecked();
    if (!this.model) return;
    this.model.TrsVoucherDetails.forEach((x) => {
      this.onValueChanges(x);
    });
    if (!this.isValidating) this.isValid();
  }

  isValid() {
    let flag: boolean = true;
    if (this.isValidating) return flag;
    if (this.model.TrsVoucherDetails && this.model?.TrsVoucherDetails.length <= 0 && this.detail && this.detail?.dataList?.length > 0)
      this.model.TrsVoucherDetails = this.detail?.dataList;

    if (!this.formGroup?.valid && !this.formGroup?.controls["StatusKindId"]?.value) this.setStatusKind();
    if (!this.goodsError) this.erroremessage = undefined;
    else flag = false;

    if (!this.formGroup.controls["FiscalYearId"].value && !this.accountService.authService.currentFiscalYear) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) this.setValue("FiscalYearId", x.Id);
      });
    }
    if (flag && this.currentVoucherKind?.ConcernInHeader && !this.formGroup.controls["ConcernId"].value) {
      this.erroremessage = "بابت انتخاب نشده است.";
      flag = false;
    }
    if (flag && this.currentVoucherKind && this.currentVoucherKind?.HasCheckVoucherDate && this.isNewRow) {
      if (new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
        this.erroremessage = "تاریخ سند نمی تواند کوچکتر از تاریخ جاری باشد.";
        flag = false;
      }
    }
    if (
      new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) <
        new Date(this.accountService.authService.currentFiscalYear.StartDate).setHours(0, 0, 0, 0) ||
      new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) >
        new Date(this.accountService.authService.currentFiscalYear.EndDate).setHours(0, 0, 0, 0)
    ) {
      this.erroremessage = "تاریخ سند باید در محدوده سال مالی باشد.";
      return false;
    }
    if (
      flag &&
      this.currentVoucherKind?.TreasuryDetailLedgerInHeader &&
      this.currentVoucherKind?.RequireTreasuryDetailLedger &&
      !this.formGroup.controls["TreasuryDetailLedgerId"].value
    ) {
      this.erroremessage = `${this.currentVoucherKind?.TreasuryDetailLedgerCaption} انتخاب نشده است.`;
      flag = false;
    }
    if (
      flag &&
      this.currentVoucherKind?.DetailLedgerInHeader &&
      this.currentVoucherKind?.RequireDetailLedger &&
      !this.formGroup.controls["DetailLedgerId"].value
    ) {
      this.erroremessage = `${this.currentVoucherKind?.DetailLedgerCaption} انتخاب نشده است.`;
      flag = false;
    }
    if (this.erroremessage && flag) flag = false;
    if (flag) {
      if (
        this.model.TrsVoucherDetails &&
        this.model.TrsVoucherDetails.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length > 0
      ) {
        if (!this.formGroup?.valid || this.formGroup.status === "DISABLED") {
          let list = this.setFormGroupErrors();
          console.log(list);
        }
        flag = this.formGroup?.valid || this.formGroup.status === "DISABLED";
      } else {
        this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
        flag = false;
      }
      if (flag) {
        this.isValidating = true;
        this.onValueChangeByApiName(undefined);
        this.isValidating = false;
        flag = !this.erroremessage;
      }
    }
    if (flag && this.model.TrsVoucherDetails.some((x) => x.State !== RowState.Delete && x.State !== RowState.Detached && x.Price <= 0)) {
      this.erroremessage = "آرتیکل سند نمی تواند بدون مبلغ باشد.";
      flag = false;
    }
    this.isValidating = false;
    return flag;
  }
  RowCheckStateChanged($event) {
    let Totalvalue: number = 0;
    if ($event && $event.length > 0) {
      $event.forEach((item) => {
        if (item) {
          if (item.RemainValue > 0) Totalvalue += item.RemainValue;
        }
      });
    }
    this.setValue("TrsVoucherTotal", Totalvalue);
  }
  VoucherSelectionChanged() {
    if (this.isActveTab("اسناد مرتبط") && this.model.TrsVoucherDetails && this.currentSettlementConcern) {
      if (this.detail?.formGroup?.get("ConcernId")?.value != null) {
        var TrsVoucherTotal = this.model.TrsVoucherDetails.filter((x) => x.ConcernId == this.currentSettlementConcern.Id)?.getSumWithKey("Price");
        this.setValue("TrsVoucherTotal", TrsVoucherTotal);
        this.SetSettlementChecked();
      }
    }
    if (this.isActveTab("سند") && this.model.TrsVoucherDetails && this.model.TrsVoucherDetails.length > 0 && this.currentSettlementConcern) {
      if (this.currentSettlementConcern && this.currentSettlementConcern.InvVoucherKindId && this.grid?.selectedRows) {
        let Totalvalue: number = 0;
        this.grid?.selectedRows.forEach((item) => {
          if (item) {
            if (item.RemainValue > 0) {
              Totalvalue += item.RemainValue;
            }
          }
        });
        if (this.model.TrsVoucherDetails && Totalvalue > 0) {
          if (!this.detail.formGroup && this.model.TrsVoucherDetails.length <= 0) this.detail.addHandler();
          var row = this.model?.TrsVoucherDetails?.find((x) => x.ConcernId == this.currentSettlementConcern.Id);
          if (row != null) row.Price = Totalvalue;
          if (this.detail?.formGroup?.get("Price")) this.detail.formGroup.get("Price").setValue(Totalvalue);
        }
      }
    }
  }
  beforupdate() {
    this.SetSettlementVoucher();
    if (this.model.TrsSettlementVouchers && this.model.TrsSettlementVouchers.length > 0) {
      if (!this.formGroup.controls["TrsSettlementVouchers"])
        this.formGroup.addControl("TrsSettlementVouchers", new UntypedFormControl(this.model.TrsSettlementVouchers));
      else this.formGroup.controls["TrsSettlementVouchers"].setValue(this.model.TrsSettlementVouchers);
    }
    if (this.detail) {
      if (this.detail.formGroup && this.detail?.formGroup?.valid) this.detail.saveCurrent();
      else this.detail.cancelHandler();
    }
    if (this.model.AccVoucherFixNumber > 0) return;
    if (this.detail && this.detail?.formGroup?.valid) this.detail.saveCurrent();
    else {
      this.detail.cancelHandler();
      if (this.model?.TrsVoucherDetails?.length > 0)
        this.model.TrsVoucherDetails = this.model.TrsVoucherDetails.filter((x) => x.State != RowState.Detached);
    }
    if (!this.isVoucherConfirmed && this.currentVoucherKind?.HasAutoConfirm && this.model.StatusKindCode != TrsStatusKind.Confirmed) {
      this.lookupservice
        .getLookupbyCode("TRS", "StatusKind", TrsStatusKind.Confirmed)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", x.Id);
            this.setValue("StatusKindCode", x.Code);
            this.setValue("StatusKindTitle", x.Title);
            if (this.model.StatusKindCode === TrsStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
            else this.confirmLabel = "تایید سند";
          }
        });
    }

    if (this.currentVoucherKind?.ConcernInHeader && this.formGroup.controls["ConcernId"].value) {
      this.model.TrsVoucherDetails.forEach((x) => {
        if (x.ConcernId !== this.formGroup.controls["ConcernId"].value) {
          x.ConcernId = this.formGroup.controls["ConcernId"].value;
          if (x.State !== RowState.Detached && x.State !== RowState.New) x.State = RowState.Modify;
        }
      });
    }
    if (this.currentVoucherKind?.SubledgerInHeader && this.formGroup.controls["SubLedgerId"].value) {
      this.model.TrsVoucherDetails.forEach((x) => {
        if (x.SubLedgerId !== this.formGroup.controls["SubLedgerId"].value) {
          x.SubLedgerId = this.formGroup.controls["SubLedgerId"].value;
          if (x.State !== RowState.Detached && x.State !== RowState.New) x.State = RowState.Modify;
        }
      });
    }
    if (this.currentVoucherKind?.DetailLedgerInHeader && this.formGroup.controls["DetailLedgerId"].value) {
      this.model.TrsVoucherDetails.forEach((x) => {
        if (x.DetailLedgerId !== this.formGroup.controls["DetailLedgerId"].value) {
          x.DetailLedgerId = this.formGroup.controls["DetailLedgerId"].value;
          if (x.State !== RowState.Detached && x.State !== RowState.New) x.State = RowState.Modify;
        }
      });
    }
    if (this.currentVoucherKind?.TreasuryDetailLedgerInHeader && this.formGroup.controls["TreasuryDetailLedgerId"].value) {
      this.model.TrsVoucherDetails.forEach((x) => {
        if (x.TreasuryDetailLedgerId !== this.formGroup.controls["TreasuryDetailLedgerId"].value) {
          x.TreasuryDetailLedgerId = this.formGroup.controls["TreasuryDetailLedgerId"].value;
          if (x.State !== RowState.Detached && x.State !== RowState.New) x.State = RowState.Modify;
        }
      });
    }
    if (this.model.TrsVoucherDetails && this.model.TrsVoucherDetails.length > 0) {
      if (!this.formGroup.controls["TrsVoucherDetails"])
        this.formGroup.addControl("TrsVoucherDetails", new UntypedFormControl(this.model.TrsVoucherDetails));
      else this.formGroup.controls["TrsVoucherDetails"].setValue(this.model.TrsVoucherDetails);
    } else this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
  }
  addControl() {
    if (this.formGroup.controls["VoucherDate"])
      this.formGroup.controls["VoucherDate"].valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => this.isValid());
    this.SetInvSellVoucher();
    this.setValue("DetailLedgerRemain", 0);
    this.setValue("TrsVoucherTotal", 0);
  }

  getFilters(columnsName: string, searchValue: string, skip: number, take: number) {
    var filters: GridFilter[] = [];
    if (searchValue) {
      const columns = columnsName.split(",");
      columns.forEach((x) => {
        {
          if (x !== "Id")
            filters.push({ Filed: x, Operator: "contains", Type: "F", Skip: skip, Take: take, Value: searchValue.toString(), Logic: "or" });
          else if (Number(searchValue) && isNumber(Number(searchValue)))
            filters.push({ Filed: x, Operator: "eq", Type: "F", Skip: skip, Take: take, Value: Number(searchValue), Logic: "or" });
        }
      });
    }
    return filters;
  }
  onDataStateChange(columnName: string, searchValue: string, skip: number, take: number): Observable<PagingDataResult<DetailLedger>> {
    var abs = new BehaviorSubject<PagingDataResult<DetailLedger>>(undefined);
    const dLkids: number[] = [];
    if (
      columnName === "DetailLedgerId" &&
      this.currentVoucherKind?.TrsVoucherKindDetailLedgerKinds &&
      this.currentVoucherKind?.TrsVoucherKindDetailLedgerKinds.length > 0
    ) {
      this.currentVoucherKind?.TrsVoucherKindDetailLedgerKinds.forEach((x) => dLkids.push(x.DetailLedgerKindId));
    }
    if (
      columnName === "TreasuryDetailLedgerId" &&
      this.currentVoucherKind?.TrsVoucherKindTreasuryDetailLedgerKinds &&
      this.currentVoucherKind?.TrsVoucherKindTreasuryDetailLedgerKinds.length > 0
    ) {
      this.currentVoucherKind?.TrsVoucherKindTreasuryDetailLedgerKinds.forEach((x) => dLkids.push(x.DetailLedgerKindId));
    }

    let apiName: string = "DetailLedger/DetailLedgerWithDetailLedgerKindIds";
    let filter = this.getFilters("Id,Code,Title", searchValue, skip, take);
    if (this.formGroup.get(columnName).value === Number(searchValue)) {
      filter = [];
      filter.push({ Filed: "Id", Operator: "eq", Type: "F", Skip: skip, Take: take, Value: Number(searchValue), Logic: "or" });
    }
    if (dLkids && dLkids.length > 0)
      filter.push({ Filed: "dLkinds", Operator: "eq", Value: dLkids, Type: "F", Skip: skip, Take: take, Logic: "and" });
    if (!filter || filter.length <= 0) filter.push({ Filed: "Code", Operator: "eq", Value: dLkids, Type: "S", Skip: skip, Take: take, Logic: "and" });
    this.httpCommonService
      .GetFilterGrid<PagingDataResult<DetailLedger>>(apiName, filter)

      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: PagingDataResult<DetailLedger>) => {
        if (x) abs.next(x);
      });
    return abs.asObservable();
  }
  setReferenceVoucherColumns() {
    this.httpCommonService
      .get("TrsVoucherHeader/GetReferenceVoucherInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.selectorService.setColumns("ReferenceId", data as []);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }

  voucherConfirm() {
    if (
      this.isValid() &&
      (this.formGroup.controls["StatusKindCode"].value === TrsStatusKind.Registered ||
        this.formGroup.controls["StatusKindCode"].value === TrsStatusKind.Confirmed)
    ) {
      this.lookupservice
        .getLookupbyCode(
          "TRS",
          "StatusKind",
          this.model.StatusKindCode === TrsStatusKind.Confirmed ? TrsStatusKind.Registered : TrsStatusKind.Confirmed
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            if (x) {
              if (this.formGroup.controls["StatusKindCode"].value === TrsStatusKind.Confirmed) {
                this.currentVoucherKind.HasAutoConfirm = false;
                this.currentVoucherKind.HasJournalVoucherAuto = false;
              }
              this.isVoucherConfirmed = this.model.StatusKindCode === TrsStatusKind.Confirmed;
              this.model.StatusKindId = x.Id;
              this.model.StatusKindCode = x.Code;
              this.model.StatusKindTitle = x.Title;
              this.setValue("StatusKindId", x.Id);
              this.setValue("StatusKindCode", x.Code);
              this.setValue("StatusKindTitle", x.Title);
              if (this.model.StatusKindCode === TrsStatusKind.Confirmed) this.confirmLabel = "برگشت از تایید";
              else this.confirmLabel = "تایید سند";
              this.save();
            }
          },
          (error) => {}
        );
    }
  }
  delete_Voucher() {
    this.sts.showToast("primary", "", "در حال حذف...");
    this.httpCommonService
      .delete(this.apiName, this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (results) => {
          this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
          this.model = undefined;
          this.currentrow = undefined;
          if (this.detail) this.detail.dataList = [];
          await this.ngOnInit();
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
        }
      );
  }
  deleteVoucher() {
    this.sts.showDialog(`آیا از حذف سند اطمینان دارید؟`, "حذف سند", DialogType.confirm, () => this.delete_Voucher());
  }
  async newVoucher() {
    this.isNewVoucher = true;
    if (this.canDeactivate()) {
      this.isClosing = false;
      this.model = undefined;
      this.currentrow = undefined;
      await this.ngOnInit();
      setTimeout(() => this.detail?.ngOnInit(), 100);
    }
  }

  hasChequeBookPrint() {
    return !this.currentSelectedRow;
  }
  chequeBookPrint(reportyKind: string) {
    let saveReportFile: SaveReportFile = <SaveReportFile>{};
    saveReportFile.ReportTitle = `الگوی چاپ چک ${this.currentSelectedRow.BankTitle}`;
    saveReportFile.FileName = `ChequeBookTemplate_${this.currentSelectedRow.BankId}`;
    saveReportFile.SystemKindName = "TRS";
    saveReportFile.CategoryName = "ChequeBookTemplate";

    let x: TrsVoucherHeader = Object.assign({}, this.model);

    x.TrsVoucherDetails = [this.currentSelectedRow];
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = reportyKind === "Print" ? ReportKind.preview : ReportKind.editReport;
    reportInfo.apiName = "TrsVoucherHeader";
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.reportTitle = saveReportFile.ReportTitle;
    reportInfo.dataList = [x];
    reportInfo.pathPreFix = "TRS";
    reportInfo.saveReportFile = saveReportFile;
    reportInfo.DataSourceName = saveReportFile.DataSourceName;

    this.dialogService
      .open(
        ChequeBookInfoFormComponent,
        {
          label: reportyKind === "Print" ? "چاپ چک" : "طراحی قالب چک",
          ChequeBookDescription: this.currentSelectedRow.Comment,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (model) => {
        if (model) {
          reportInfo.reportVariables = model;

          const menu = <ITab>{
            title: saveReportFile.ReportTitle,
            isCloseable: true,
            active: true,
            responsive: true,
            componentType: StimulSoftReportComponent,
            data: [{ provide: ReportInfo, useValue: reportInfo }],
          };
          this.tabsservice.open(menu);
        }
      });
  }
  voucherRefrenceTo() {}
  accountAccVoucher(create: boolean = true) {
    if (this.canDeactivate()) {
      let gridFilter: GridFilter[] = [];
      let TrsVoucherHeaderIds: number[] = [];
      TrsVoucherHeaderIds.push(this.model.Id);
      let filter: GridFilter = {
        Type: "F",
        Filed: "TrsVoucherHeaderIds",
        Value: TrsVoucherHeaderIds,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      };
      gridFilter.push(filter);
      if (this.model.AccVoucherFixNumber !== undefined && this.model.AccVoucherFixNumber > 0 && !create) this.deleteAccVoucher(gridFilter);
      if (create) this.createAccVoucher(gridFilter);
    }
  }
  createAccVoucher(gridFilter: GridFilter[]) {
    this.splashFormService.openDialog("", "در حال صدور سند حسابداری");
    this.httpCommonService
      .create(this.apiName + "/CreateAccVoucher", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          if (x) {
            this.isClosing = false;
            this.splashFormService.closeLoading();
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            setTimeout(async () => {
              await this.ngOnInit();
              this.cd.markForCheck();
            }, 200);
            this.sts.showDialog("سند با موفقیت صادر شد.", "");
          }
        },
        (error) => {
          this.currentVoucherKind.HasJournalVoucherAuto = false;
          setTimeout(async () => {
            await this.ngOnInit();
            this.cd.markForCheck();
          }, 200);
          this.splashFormService.closeLoading();
          this.isClosing = false;
          this.sts.showDialog(`خطا در صدور اسناد${Utilities.getHttpResponseMessage(error)}`, "");
        }
      );
  }
  deleteAccVoucher(gridFilter: GridFilter[]) {
    this.splashFormService.openDialog("", "در حال حذف سند حسابداری");
    this.httpCommonService
      .create(this.apiName.split("/")[0] + "/DeleteAccVoucher", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (x) => {
          if (x) {
            this.splashFormService.closeLoading();
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            this.sts.showDialog("سند با موفقیت حذف شد.", "");
            await this.ngOnInit();
            setTimeout(() => {
              this.cd.markForCheck();
            }, 50);
          }
        },
        async (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در حذف اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
          await this.ngOnInit();
          setTimeout(() => {
            this.cd.markForCheck();
          }, 50);
        }
      );
  }
  viewAccVoucher() {
    this.httpCommonService
      .getItem("TrsVoucherHeader/ViewAccVoucher", this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          var datatrasfer: Datatransfer = <Datatransfer>{};
          datatrasfer.apiName = "AccVoucherHeader";
          datatrasfer.label = "سند حسابداری";
          datatrasfer.areaName = "Accounting";
          datatrasfer.currentrow = x;
          const menu = <ITab>{
            title: `سند حسابداری-(نمایش)`,
            isCloseable: true,
            active: true,
            responsive: true,
            componentType: AccVoucherFormComponent,
            // modulePath: this.tabsservice.getActiveTab().modulePath,
            data: [
              { provide: EntityBase, useValue: x },
              { provide: Datatransfer, useValue: datatrasfer },
              { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: x[""] } },
            ],
          };
          this.tabsservice.open(menu);
        },
        (error) => this.sts.showDialog(`خطا در نمایش سند:${Utilities.getHttpResponseMessage(error)}`, "خطا")
      );
  }
  chequeBookAverage() {}
  ngOnDestroy() {
    super.ngOnDestroy();
    this.selectorService.setDataStateChange("TreasuryDetailLedgerId", undefined);
    this.selectorService.setDataStateChange("DetailLedgerId", undefined);
    this.selectorService.setDataList("ReferenceVoucherKindId", undefined);
    this.selectorService.setDataList("ConcernId", undefined);
    this.selectorService.setColumns("ReferenceId", undefined);

    this.TrsVoucherDetailsColumns = undefined;
    this.reportKinds = undefined;
  }
  loadVoucherList() {
    this.inputEditorform = TrsVoucherModalListComponent;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          label: this.label,
          currentVoucherKindId: this.currentVoucherKind.Id,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (model) => {
        if (model) {
          if (this.detail) this.detail.cancelHandler();
          this.currentrow = model;
          this.id = this.currentrow.Id;
          await this.ngOnInit();
        }
      });
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
    this.VoucherSelectionChanged();
  }
  private GetSettelemntDetailLedgherId(): number {
    let result = undefined;
    if (this.grdSettlementVoucher && this.grdSettlementVoucher.length > 0) {
      var record = this.grdSettlementVoucher[0];
      if (record) result = record.DetailLedgerId;
    }
    return result;
  }

  SetSettlementVoucher() {
    if (
      this.model &&
      this.currentSettlementConcern &&
      this.model.TrsVoucherDetails &&
      this.model.TrsVoucherDetails.some((x) => x.ConcernId == this.currentSettlementConcern.Id) &&
      this.grid?.selectedRows
    ) {
      var Totalvalue = this.model.TrsVoucherDetails.filter((x) => x.ConcernId == this.currentSettlementConcern.Id)?.getSumWithKey("Price");

      this.grid.selectedRows.forEach((item) => {
        if (Totalvalue > 0 && vh.RemainValue > 0) {
          var vh = item;
          var entity = this.model.TrsSettlementVouchers.find((x) => x.InvVoucherId == vh.Id);
          if (!entity) {
            entity = <TrsSettlementVoucher>{};
            if (this.currentSettlementConcern.IsWarehouse) entity.InvVoucherId = vh.Id;
            else entity.SellVoucherId = vh.Id;
            entity.TrsConcernId = this.currentSettlementConcern.Id;
            entity.State = RowState.New;
            if (
              !this.model.TrsSettlementVouchers.some(
                (x) => x.TrsConcernId === entity.TrsConcernId && (x.InvVoucherId === entity.InvVoucherId || x.SellVoucherId === entity.SellVoucherId)
              )
            )
              this.model.TrsSettlementVouchers.push(entity);
          }
          if (Totalvalue > vh.RemainValue) {
            entity.SettlementValue = vh.RemainValue;
          } else {
            entity.SettlementValue = Totalvalue;
          }
          Totalvalue -= entity.SettlementValue;
        }
      });
    }
  }
  SetCurrentSettlementConcern() {
    if (this.formGroup?.get("TrsConcernId")?.value || (this.model.TrsSettlementVouchers && this.model.TrsSettlementVouchers.length > 0)) {
      if (this.formGroup?.get("TrsConcernId")?.value) {
        this.httpCommonService
          .getItem("TrsConcern/GetLookup", this.formGroup?.get("TrsConcernId")?.value)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (data) => {
              this.currentSettlementConcern = data[0];
            },
            (error) => this.getFailedHelper(error)
          );
      } else {
        this.httpCommonService
          .getItem("TrsConcern/GetLookup", this.model.TrsSettlementVouchers[0].TrsConcernId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (data) => {
              this.currentSettlementConcern = data[0];
            },
            (error) => this.getFailedHelper(error)
          );
      }
    }
  }
  SetInvSellVoucher() {
    this.SetCurrentSettlementConcern();
    if (!this.SelectedSettlement || this.SelectedSettlement.length <= 0) {
      this.SetSettlementChecked();
    }
    if (this.currentSettlementConcern && this.currentSettlementConcern.InvVoucherKindId) {
      if (this.currentSettlementConcern.IsWarehouse) this.GetInvVoucher();
      else this.GetSellVoucher();
    }
    if (this.currentSettlementConcern && this.currentSettlementConcern.InvVoucherKindId) {
      this.SetSettlementVoucher();
    }
  }
  private GetSellVoucher() {
    if (!this.currentSettlementConcern) return;
    if (!this.currentDetailLedger || !this.currentDetailLedger.Id) {
      this.sts.showDialog(`${this.currentVoucherKind.DetailLedgerCaption} انتخاب نشده است.`, "خطا اسناد مرتبط");
      return;
    }
    let StatusKindIds: number[] = [];
    this.lookupservice
      .getLookupbyCategory("SELL", "StatusKind")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (x) {
          x.filter((f) => f.Code !== 4).forEach((s) => {
            StatusKindIds.push(s.Id);
          });
        }
      });
    let FromVoucherDate: Date = this.currentSettlementConcern.InvVoucherKindDate;
    let VoucherDate = new Date(this.formGroup.get("VoucherDate").value);
    if (VoucherDate) VoucherDate.setDate(VoucherDate.getDate() - 365);
    if (FromVoucherDate && FromVoucherDate > VoucherDate) FromVoucherDate = VoucherDate;
    if (!this.formGroup.get("VoucherDate").value || !this.model.FiscalYearId) return;
    let gridFilter: GridFilter[] = [];
    gridFilter.push({ Type: "F", Filed: "FiscalYearId", Value: this.model.FiscalYearId, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    gridFilter.push({
      Type: "F",
      Filed: "VoucherKindId",
      Value: this.currentSettlementConcern.InvVoucherKindId,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    gridFilter.push({ Type: "F", Filed: "BranchId", Value: this.model.BranchId, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    gridFilter.push({ Type: "F", Filed: "StartVoucherDate", Value: FromVoucherDate, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    gridFilter.push({
      Type: "F",
      Filed: "EndVoucherDate",
      Value: this.formGroup.get("VoucherDate").value,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    gridFilter.push({ Type: "F", Filed: "StatusKindIds", Value: StatusKindIds, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    this.httpCommonService
      .create("SellVoucherHeader/GetWithCustomFilter", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.grdSettlementVoucher = data;
          if (this.grid) this.grid.dataList = data;
          this.SetSettlementChecked();
        },
        (error) => this.getFailedHelper(error)
      );
  }

  private GetInvVoucher() {
    if (!this.currentSettlementConcern) return;
    if (!this.currentDetailLedger || !this.currentDetailLedger.Id) {
      this.sts.showDialog(`${this.currentVoucherKind.DetailLedgerCaption} انتخاب نشده است.`, "خطای انتخاب اسناد مرتبط");
      return;
    }
    let StatusKindIds: number[] = [];
    this.lookupservice
      .getLookupbyCategory("INV", "StatusKind")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (x) {
          x.filter((f) => f.Code !== 4).forEach((s) => {
            StatusKindIds.push(s.Id);
          });
        }
      });
    let FromVoucherDate: Date = this.currentSettlementConcern.InvVoucherKindDate;
    let VoucherDate = new Date(this.formGroup.get("VoucherDate").value);
    VoucherDate.setDate(VoucherDate.getDate() - 365);
    if (FromVoucherDate && FromVoucherDate > VoucherDate) FromVoucherDate = VoucherDate;
    if (!FromVoucherDate) FromVoucherDate = VoucherDate;
    let gridFilter: GridFilter[] = [];
    let DetailLedgerIds: number[] = [];
    if (this.currentDetailLedger?.Id) DetailLedgerIds.push(this.currentDetailLedger?.Id);
    gridFilter.push({ Type: "F", Filed: "FiscalYearId", Value: this.model.FiscalYearId, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    gridFilter.push({
      Type: "F",
      Filed: "VoucherKindId",
      Value: this.currentSettlementConcern.InvVoucherKindId,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    gridFilter.push({ Type: "F", Filed: "DetailLedgerIds", Value: DetailLedgerIds, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    gridFilter.push({ Type: "F", Filed: "BranchId", Value: this.model.BranchId, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    gridFilter.push({ Type: "F", Filed: "StartVoucherDate", Value: FromVoucherDate, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    gridFilter.push({
      Type: "F",
      Filed: "EndVoucherDate",
      Value: this.formGroup.get("VoucherDate").value,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    gridFilter.push({ Type: "F", Filed: "StatusKindIds", Value: StatusKindIds, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    if (this.model.Id)
      gridFilter.push({ Type: "F", Filed: "SettlementVoucherId", Value: this.model.Id, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });

    this.httpCommonService
      .create("InvVoucherHeader/GetWithCustomFilter", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.grdSettlementVoucher = data;
          if (this.grid) this.grid.dataList = data;
          this.SetSettlementChecked();
        },
        (error) => this.getFailedHelper(error)
      );
  }
  private SetSettlementChecked() {
    this.SelectedSettlement = [];
    if (!this.model.TrsSettlementVouchers) return;
    this.model.TrsSettlementVouchers.filter((x) => x.TrsConcernId === this.currentSettlementConcern?.Id).forEach((item) => {
      if (!this.SelectedSettlement.some((x) => x === (item.InvVoucherId ?? item.SellVoucherId)))
        this.SelectedSettlement.push(item.InvVoucherId ?? item.SellVoucherId);
    });
    if (this.grid) this.grid.mySelection = this.SelectedSettlement;
    this.cd.markForCheck();
  }

  setTrsVoucherDetailsColumns() {
    this.TrsSettlementVoucherColumns = [];
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "سریال",
      controlType: FormControlTypes.textbox,
      modelName: "Id",
      disabled: false,
      name: "Id",
      order: 0,
      textType: "text",
      formVisible: false,
      listVisible: false,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "انبار",
      controlType: FormControlTypes.textbox,
      modelName: "WarehouseTitle",
      disabled: false,
      name: "WarehouseTitle",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "نوع سند",
      controlType: FormControlTypes.textbox,
      modelName: "VoucherKindTitle",
      disabled: false,
      name: "VoucherKindTitle",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "شماره سند",
      controlType: FormControlTypes.textbox,
      modelName: "VoucherNo",
      disabled: false,
      name: "VoucherNo",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "شماره پیگیری",
      controlType: FormControlTypes.textbox,
      modelName: "SlaveNo",
      disabled: false,
      name: "SlaveNo",
      order: 0,
      textType: "text",
      formVisible: false,
      listVisible: false,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "تاریخ سند",
      controlType: FormControlTypes.textbox,
      modelName: "ShamsiVoucherDate",
      disabled: false,
      name: "ShamsiVoucherDate",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "کد تفصیلی",
      controlType: FormControlTypes.textbox,
      modelName: "DetailLedgerCode",
      disabled: false,
      name: "DetailLedgerCode",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "عنوان تفصیلی",
      controlType: FormControlTypes.textbox,
      modelName: "DetailLedgerTitle",
      disabled: false,
      name: "DetailLedgerTitle",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "سند مبنا",
      controlType: FormControlTypes.textbox,
      modelName: "ReferenceVoucherKindTitle",
      disabled: false,
      name: "ReferenceVoucherKindTitle",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "وضعیت سند",
      controlType: FormControlTypes.textbox,
      modelName: "StatusKindTitle",
      disabled: false,
      name: "StatusKindTitle",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: false,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "سند حسابداری",
      controlType: FormControlTypes.textbox,
      modelName: "AccVoucherNo",
      disabled: false,
      name: "AccVoucherNo",
      order: 0,
      textType: "text",
      formVisible: false,
      listVisible: false,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "جمع خالص",
      controlType: FormControlTypes.textbox,
      modelName: "TotalPrice",
      disabled: false,
      name: "TotalPrice",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "مبلغ تسویه شده",
      controlType: FormControlTypes.textbox,
      modelName: "PaymentValue",
      disabled: false,
      name: "PaymentValue",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
    this.TrsSettlementVoucherColumns.push(<form_control>{
      label: "مانده",
      controlType: FormControlTypes.textbox,
      modelName: "RemainValue",
      disabled: false,
      name: "RemainValue",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
      columnWidth: 101,
    });
  }
}
